export const CALL_PHONE_DISPLAY = '01708 594 024';
export const CALL_PHONE_TEL = '01708594024';

export const WHATSAPP_PHONE_DISPLAY = '+44 7407669561';
export const WHATSAPP_PHONE_WA = '447407669561';
export const WHATSAPP_MESSAGE = 'Hi, I need help with a product enquiry.';
